import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Header } from "@perxis-auto/ui-kit/lib/components/Header";
import styles from "./FavoritesHeader.module.scss.js";
const FavoritesHeader = memo(function FavoritesHeader2({
  t,
  total,
  onBackClick,
  onClearClick
}) {
  return /* @__PURE__ */ jsx(Header, { border: false, className: styles.favoritesHeader, children: /* @__PURE__ */ jsxs(Row, { align: "middle", gutter: [0, "vertical-sky"], children: [
    /* @__PURE__ */ jsx(Col, { xs: { span: 12, order: 1 }, sm: { span: 12, order: 1 }, md: { span: 6, order: 1 }, children: /* @__PURE__ */ jsx(Row, { justify: "start", children: /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Header.Link, { icon: "back", iconPosition: "left", onClick: onBackClick, children: t("widgets.favoritesHeader.backLabel") }) }) }) }),
    /* @__PURE__ */ jsx(Col, { xs: { span: 24, order: 3 }, sm: { span: 24, order: 3 }, md: { span: 12, order: 2 }, children: /* @__PURE__ */ jsx(Row, { justify: "center", children: /* @__PURE__ */ jsx(
      Header.Heading,
      {
        title: t("widgets.favoritesHeader.title"),
        badge: {
          count: total,
          type: "ghost"
        }
      }
    ) }) }),
    /* @__PURE__ */ jsx(Col, { xs: { span: 12, order: 2 }, sm: { span: 12, order: 2 }, md: { span: 6, order: 3 }, children: /* @__PURE__ */ jsx(Row, { justify: "end", children: /* @__PURE__ */ jsx(Col, { hidden: !total, children: /* @__PURE__ */ jsx(Header.Link, { icon: "trash", iconPosition: "right", onClick: onClearClick, children: t("widgets.favoritesHeader.clearLabel") }) }) }) })
  ] }) });
});
export {
  FavoritesHeader
};
